import { useEffect } from 'react';
import { useAppDispatch } from '../store/hooks';
import { setTheme } from '../store/slices/themeSlice';
import { Theme } from '../types';

export const useThemeInitialization = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Get theme from localStorage or default to 'system'
    const savedTheme = localStorage.getItem('theme') as Theme;
    const defaultTheme: Theme = savedTheme || 'system';
    
    // Set the theme in Redux store
    dispatch(setTheme(defaultTheme));
  }, [dispatch]);
}; 